var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "12", height: "20", viewBox: "0 0 12 20" }, props),
    React.createElement("path", { fill: "#303030", fillRule: "evenodd", d: "M8.094 13.233a.75.75 0 0 1-1.088 1.034l-3.8-4a.75.75 0 0 1 0-1.034l3.8-4a.75.75 0 0 1 1.088 1.034L4.784 9.75l3.31 3.483z" })
  );
});